import React from 'react';

import { Heading, Projects } from '../../../components';



const ProjectSection = () => {
  return (

    <section>

      {/* Section heading */}
      <Heading title={'Our Projects'} subTitle={'Discover Our Adventure Initiatives'} />

      {/* Projects Section */}
      <Projects />

    </section>

  );
}

export default ProjectSection;